import claudeLogo from "@/assets/settings/claude.svg";
import mistralLogo from "@/assets/settings/mistral.svg";
import openaiLogo from "@/assets/settings/openai.svg";

export const LLM_PROVIDER_LOGOS = {
  openai: openaiLogo,
  mistral: mistralLogo,
  anthropic: claudeLogo,
} as const;

export type LLMProvider = keyof typeof LLM_PROVIDER_LOGOS;
